import Radiusses from '../../tokens/Radiusses';

export interface RadiusesTheme {
  radiuses: {
    S: Radiusses;
    M: Radiusses;
    L: Radiusses;
    XL: Radiusses;
    XXL: Radiusses;
  };
}

export const bisRadiuses: RadiusesTheme = {
  radiuses: {
    S: Radiusses.M,
    M: Radiusses.M,
    L: Radiusses.M,
    XL: Radiusses.XL,
    XXL: Radiusses.XXL,
  },
};
